import { render, staticRenderFns } from "./CopperButton.vue?vue&type=template&id=bc1d798a&scoped=true"
import script from "./CopperButton.vue?vue&type=script&lang=ts"
export * from "./CopperButton.vue?vue&type=script&lang=ts"
import style0 from "./CopperButton.vue?vue&type=style&index=0&id=bc1d798a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d798a",
  null
  
)

export default component.exports